import React from "react";
import "../css/section-two.scss";
import dartIcon from "../img/dart.png";
import eyeIcon from "../img/eye.png";
import rocketIcon from "../img/rocket.png";
import checklistIcon from "../img/checklist.png";
import InfoCard from "./info-card";
import bscImage from "../img/bsc.png";
import { useSelector } from "react-redux";
import { userConstants } from "../../../_constants";

export const SectionTwo = ({
  strategies,
  programs,
  hospitalGraphUrl,
  goalGroup,
  year,
}) => {
  const { token } = useSelector((state) => state.globalStorage);

  return (
    <div className="section_2">
      <div className="strategies_container">
        <div className="strategy_box">
          <img src={dartIcon} alt="" className="strategy_logo" />
          <span className="strategy_title iran-sans_Bold">رسـالت</span>
          <div className="border mt-2"></div>
          <div className="strategy_list">
            <span className="strategy_item iran-sans_Bold">
              {strategies?.resalat}
            </span>
          </div>
        </div>
        <div className="strategy_box">
          <img src={eyeIcon} alt="" className="strategy_logo" />
          <span className="strategy_title iran-sans_Bold">چشـم انـداز</span>
          <div className="border mt-2"></div>
          <div className="strategy_list">
            <span className="strategy_item iran-sans_Bold">
              {strategies?.cheshm_andaz}
            </span>
          </div>
        </div>
        <div className="strategy_box">
          <img src={rocketIcon} alt="" className="strategy_logo" />
          <span className="strategy_title iran-sans_Bold">
            ارزش هـای بنیـادی{" "}
          </span>
          <div className="border mt-2"></div>
          <div className="strategy_list">
            {strategies?.arzesh_bonyadi?.map((arzesh, index) => (
              <span className="strategy_item iran-sans_Bold" key={index}>
                {arzesh}
              </span>
            ))}
          </div>
        </div>
      </div>
      <InfoCard
        title="نمـودار سازمـانـی بیمارستـان"
        className="organizational_hospital_chart"
      >
        <img
          src={`${userConstants.SERVER_URL}${hospitalGraphUrl}`}
          alt=""
          className="hospital_graph"
        />
      </InfoCard>
      <div className="operational_plans">
        <p className="operational_plans_title iran-sans_Bold">
          برنامـه هـای عملیاتـی
        </p>
        <button
          onClick={() =>
            window.open(
              "https://snjob.ir/management/#/improve_quality/programs?to_action_plan=true",
              "_blank"
            )
          }
          className="operational_plans_btn iran-sans_Bold"
        >
          مشاهـده جزییـات برنامـه عملیاتـی
        </button>
        <InfoCard title="اطلاعات کلی" className="operational_plans_container">
          <div className="operational_plans_list">
            <div className="operational_plans_item">
              <div className="left_side">
                <p className="left_side_title iran-sans_Bold">
                  تعـداد کل برنامـه هـای عملیـاتـی
                </p>
                <span className="left_side_count">
                  {programs?.all_programs || 0}
                </span>
              </div>
            </div>
            <div className="operational_plans_item">
              <div className="left_side">
                <p className="left_side_title iran-sans_Bold">
                  تحقـق برنامـه هـا
                </p>
                <span className="left_side_count">
                  {programs?.realization_percent || 0}%
                </span>
              </div>
            </div>
            <div className="operational_plans_item">
              <div className="left_side">
                <p className="left_side_title iran-sans_Bold">
                  فعالیت هـای انجـام شـده
                </p>
                <span className="left_side_count">
                  {programs?.done_steps_percentage?.toFixed(0) || 0}%
                </span>
              </div>
            </div>
            <div className="operational_plans_item">
              <div className="left_side">
                <p className="left_side_title iran-sans_Bold">
                  فعالیت هـای در دست اقـدام
                </p>
                <span className="left_side_count">
                  {programs?.doing_steps_percentage?.toFixed(0) || 0}%
                </span>
              </div>
            </div>
            <div className="operational_plans_item">
              <div className="left_side">
                <p className="left_side_title iran-sans_Bold">
                  فعالیت هـای انجـام نشده
                </p>
                <span className="left_side_count">
                  {programs?.not_start_steps_percentage?.toFixed(0) || 0}%
                </span>
              </div>
            </div>
          </div>
          <div className="operational_plans_card_container">
            {goalGroup?.map((goal, index) => (
              <div className="operational_plans_card" key={index}>
                <p className="title">{goal.strategy_goal}</p>
                <ul className="operational_plan_list">
                  {goal.programs?.map((program, pIndex) => (
                    <li
                      className="operational_plan_item"
                      key={`item-${index}-${pIndex}`}
                    >
                      {program.title}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </InfoCard>
      </div>
      <div className="hospital_indicators">
        <p className="title iran-sans_Bold">شـاخص هـای بیمـارستـان</p>
        <p className="caption iran-sans_Bold">
          برخـی از شـاخص هـای مهـم و کلیـدی در بیمارستـان که بر اسـاس وجـه هـای
          کارت امتیـازی متوازن تهیـه گردیده است{" "}
        </p>
        <button
          className="see_btn iran-sans_Bold"
          onClick={() =>
            window.open(
              `https://app.snjob.ir/bsc?Token=${token}&Year=${year}`,
              "_blank"
            )
          }
        >
          جهت مشاهده کارت امتیازی متوازن کلیک کنید
        </button>
        <img
          onClick={() =>
            window.open(
              `https://app.snjob.ir/bsc?Token=${token}&Year=${year}`,
              "_blank"
            )
          }
          className="bsc_table"
          title="مشاهده"
          src={bscImage}
          alt=""
        />
      </div>
    </div>
  );
};
